import { launchdarklyIdentify } from '../launchdarkly/client';
import { useToken } from 'shared/hooks';
import { datadogIdentify } from 'shared/utils/integrations/datadog';
import { identify as mixpanelIdentify } from 'shared/utils/mixpanel';
/**
 * Initializes integrations with the id we know very early via the jwt token.
 */
export var earlyIntegrationsIdentify = function () {
    var token = useToken();
    var userId = token === null || token === void 0 ? void 0 : token.sub;
    if (!userId) {
        // eslint-disable-next-line no-console
        console.warn('no userid available integration identify skipped.');
        return;
    }
    launchdarklyIdentify(userId);
    datadogIdentify(userId);
    mixpanelIdentify(userId, { role: token.scopes.join(', ') });
};
